import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { FiltersM, typesApex } from '../../../components/models';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { DataService } from '../../../services/data/data.service';
import { formatear } from '../../funciones/funcionesGenerales';
import { ComercialService, PERIODICITY, PerspectiveIdentifier } from '../../../services/comercial/comercial.service';
import { firstValueFrom } from 'rxjs';
import { Meses } from '../../../models/Formulacion/indicadores-metas/datos';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { TranslateService } from '@ngx-translate/core';
import { messages } from '../../funciones/mensajes';
import { ConstantesImagenes } from '../../../models/Cuestionarios/codigoimagenes';
import Swal from 'sweetalert2';
import { generatePDF } from '../../funciones/makePdf';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.addVirtualFileSystem(pdfFonts);

@Component({
  selector: 'app-metas',
  templateUrl: './metas.component.html',
  styleUrl: './metas.component.css'
})
export class MetasComponent {
  private pdfFile: any;

  Filters = FiltersM;
  zonas = [];
  consolidadoZona = true;
  expandAll = true;
  sucursales = [];
  consolidado = true;
  periodos = [];
  month = 'Enero';
  perspective1: string;
  perspective2: string;
  encabezados = [0, 1, 2, 3, 4, 5, 6, 9, 10]
  dataTable = [];
  /** Suma de las Zonas visibles; % recalculado sobre el total, no promediado. */
  totalGeneral = [];
  modal = false;
  modalSaldos = false;
  modalClientes = false;

  types = typesApex;
  paletaSaldos = ['#00245C', '#0075C9', '#BAD8EB'];
  paletaClientes = ['#144733', '#3FAE2A', '#DEEFA4'];
  viewTabla = true;
  // Independientes: cada gráfica prende/apaga sus propias etiquetas.
  etiquetasShowSaldos = true;
  etiquetasShowClientes = true;
  // Independientes: Saldos y Clientes pueden verse con distinto tipo de gráfica a la vez.
  chartTypeSaldos: typesApex = typesApex.COMBO;
  chartTypeClientes: typesApex = typesApex.COMBO;
  chartLabelsSaldos = [];
  chartLabelsClientes = [];
  chartDataSaldos = [];
  chartAxisYSaldos = [];
  chartDataClientes = [];
  chartAxisYClientes = [];
  @ViewChild('graficasSaldos') graficasSaldos: GraficadorComponent;
  @ViewChild('graficasClientes') graficasClientes: GraficadorComponent;

  tarjets = [];
  tarjetasSkeleton = ['','','',''];
  skeleton = true;
  private token;
  private periodoInicial: any;
  constructor(
    public dataService: DataService,
    public excel: ExcelService,
    public translate: TranslateService,
    private readonly comercialService: ComercialService,
    private readonly cdr: ChangeDetectorRef,
  ){
    formatear.momentAbrev();
    this.getPeriods();
  }

  private async getPeriods(){
    // get() espera a que cargue el diccionario; instant() aquí llegaba antes y regresaba la llave cruda.
    this.perspective1 = await firstValueFrom(this.translate.get('comercial.asosiatividad.metas.titulo-10-tabla'));
    this.perspective2 = await firstValueFrom(this.translate.get('comercial.asosiatividad.metas.titulo-meta-anual-clientes'));
    const token = await firstValueFrom(this.comercialService.loginOdefFinanciera());
    this.token = token['accessToken'];

    const periodos = await firstValueFrom(
      this.comercialService.getPeriodosCreditos(this.token)
    );
    const auxYear = this.comercialService.ordenarPeriodos(periodos['periods']).map(y => {
      return {
        anio: y.year,
        series: y.months.map(m => {
          return {
            mes: Meses.getMesesNumbertoString(m, true),
            mesS: Meses.getMesesNumbertoString(m, false),
            check: false,
            an: y.year,
            anio: (`${y.year}`).substring(2),
            periodo: Meses.getMesesNumbertoString(m, true)+'.'+(`${y.year}`).substring(2),
            visible: true,
            utilizable: true,
          }
        }),
        visible: true,
        utilizable: true,
      }
    });

    const elegido = await this.comercialService.ultimoPeriodoConDatos(
      auxYear.flatMap(y => y.series),
      async periodo => {
        const r = await firstValueFrom(
          this.comercialService.getCreditoA1({
            perspective: PerspectiveIdentifier.REGION,
            period: periodo,
            granularity: PERIODICITY.MONTH
          }, this.token)
        );
        return r['results']?.length > 0;
      }
    );
    this.periodoInicial = elegido;
    elegido.check = true;
    this.periodos = auxYear;
    this.month = elegido.mesS;

    await this.getZonas();
    this.getData();
  }

  private getPeriodo(){
    const an = this.periodos.find(y => y.series.find(m => m.check));
    const mes = an.series.find(m => m.check);

    return `${mes.an}-${Meses.getMesesNum(mes.mes)}`;
  }

  /** Fecha corta para mostrar en tarjetas/gráficas, igual que en el resto del sistema (ej. "jun 26"). */
  getPeriodoCorto(): string{
    const an = this.periodos.find(y => y.series.find(m => m.check));
    const mes = an?.series.find(m => m.check);
    return mes ? `${mes.mes} ${mes.anio}` : '';
  }

  /** Fecha, y si hay Zona/Agencia filtrada se le agrega " | <nombre>". */
  piePeriodoNivel(): string{
    const nivel = this.nivelActual();
    const consolidado = this.translate.instant('comercial.asosiatividad.metas.consolidado');
    return nivel === consolidado ? this.getPeriodoCorto() : `${this.getPeriodoCorto()} | ${nivel}`;
  }

  /** Trae las regiones (Zona) y, para cada una, sus agencias reales. */
  private async getZonas(){
    const per = this.getPeriodo();

    const data = await firstValueFrom(
      this.comercialService.getCreditoA1({
        perspective: PerspectiveIdentifier.REGION,
        period: per,
        granularity: PERIODICITY.MONTH
      }, this.token)
    );
    const regiones = data['results'].sort((a, b) => {
      if (a.description === 'SIN REGION') return 1;
      if (b.description === 'SIN REGION') return -1;
      return a.description.localeCompare(b.description, 'es', { sensitivity: 'base' });
    });

    const zonas = [];
    for(const r of regiones){
      const filters = { [PerspectiveIdentifier.REGION]: [r.code] };
      const sucData = await firstValueFrom(
        this.comercialService.getCreditoA1({
          perspective: PerspectiveIdentifier.BRANCH_OFFICE,
          period: per,
          granularity: PERIODICITY.MONTH,
          filters
        }, this.token)
      );
      const sucursalesZona = sucData['results']
        .sort((a, b) => a.description.localeCompare(b.description, 'es'))
        .map(s => ({ name: formatear.capitalizar(s.description), code: s.code, check: false }));

      zonas.push({
        name: formatear.capitalizar(r.description),
        code: r.code,
        check: false,
        expandido: true,
        visible: true,
        sucursales: sucursalesZona
      });
    }

    this.zonas = zonas;
    this.consolidadoZona = true;
    this.actualizarSucursalesPorZona();
  }
  /** Llena el filtro de agencias según la zona seleccionada, y qué zonas se ven en la tabla. */
  private actualizarSucursalesPorZona(){
    if(this.consolidadoZona){
      this.sucursales = this.zonas.flatMap(z => z.sucursales.map(s => ({...s, check: false})));
      this.zonas.forEach(z => z.visible = true);
    }else{
      const zonaSeleccionada = this.zonas.find(z => z.check);
      this.sucursales = zonaSeleccionada
        ? zonaSeleccionada.sucursales.map(s => ({...s, check: false}))
        : [];
      this.zonas.forEach(z => z.visible = z === zonaSeleccionada);
    }
    this.consolidado = true;
  }
  /** Expande/contrae una zona en la tabla, o todas si se manda 'consolidado'. */
  expandirElementos(elemento){
    if(elemento === 'consolidado'){
      this.expandAll = !this.expandAll;
      this.zonas.forEach(z => z.expandido = this.expandAll);
    }else{
      const z = this.zonas.find(z => z.name === elemento.name);
      z.expandido = !z.expandido;
      this.expandAll = this.zonas.every(z => z.expandido);
    }
  }

  /** Expande/contrae los asesores de una agencia; se traen la primera vez que se expande. */
  async expandirAsesores(suc){
    suc.asesoresExpandido = !suc.asesoresExpandido;
    if(suc.asesoresExpandido && !this.asesoresVigentes(suc)){
      await this.fetchAsesores(suc);
    }
  }

  /** true si la agencia ya tiene sus asesores cargados del período seleccionado. */
  private asesoresVigentes(suc): boolean{
    return !!suc.asesores && suc.asesoresPeriodo === this.getPeriodo();
  }

  /** Trae los asesores de la agencia filtrada para la gráfica, aunque la fila siga contraída. */
  private async cargarAsesoresParaGrafica(){
    if(this.consolidadoZona || this.consolidado){ return; }

    const codigoAgenciaSel = this.sucursales.find(s => s.check)?.code;
    const sucSel = this.zonas.flatMap(z => z.sucursales).find(s => s.code === codigoAgenciaSel);
    if(!sucSel || this.asesoresVigentes(sucSel)){ return; }

    await this.fetchAsesores(sucSel);
    this.actualizarGrafica();
    this.cdr.detectChanges();
  }

  private async fetchAsesores(suc){
    if(suc.cargandoAsesores){ return; }
    const per = this.getPeriodo();
    const anio = per.split('-')[0];
    if(suc.asesoresPeriodo !== per){ suc.asesores = undefined; }
    suc.cargandoAsesores = true;
    this.cdr.detectChanges();

    let credMes: any, partMes: any, credAnio: any, partAnio: any;
    try{
      [credMes, partMes, credAnio, partAnio] = await Promise.all([
        firstValueFrom(this.comercialService.getAsesoresCreditos(suc.code, per, PERIODICITY.MONTH, this.token)),
        firstValueFrom(this.comercialService.getAsesoresPartners(suc.code, per, PERIODICITY.MONTH, this.token)),
        firstValueFrom(this.comercialService.getAsesoresCreditos(suc.code, anio, PERIODICITY.YEAR, this.token)),
        firstValueFrom(this.comercialService.getAsesoresPartners(suc.code, anio, PERIODICITY.YEAR, this.token)),
      ]);
    }catch(error){
      suc.asesores = [];
      suc.cargandoAsesores = false;
      this.cdr.detectChanges();
      return;
    }

    const partnersMesPorAsesor = new Map<number, any>((partMes['results'] ?? []).map((r: any) => [r.code, r]));
    const creditosAnioPorAsesor = new Map<number, any>((credAnio['results'] ?? []).map((r: any) => [r.code, r]));
    const partnersAnioPorAsesor = new Map<number, any>((partAnio['results'] ?? []).map((r: any) => [r.code, r]));

    // Aquí null y 0 no son lo mismo: null = sin meta cargada ("-"), 0 = meta/real en cero.
    const num = (v: number) => v == null ? null : Number(v.toFixed(2));
    const numEntero = (v: number) => v == null ? null : Math.round(v);
    const pctOrNull = (v: number) => v == null ? null : Number((v * 100).toFixed(1));

    suc.asesores = (credMes['results'] ?? []).map((r: any) => {
      const partRow = partnersMesPorAsesor.get(r.code) ?? {};
      const credAnioRow = creditosAnioPorAsesor.get(r.code) ?? {};
      const partAnioRow = partnersAnioPorAsesor.get(r.code) ?? {};

      return {
        name: r.description,
        code: r.code,
        datos: [
          num(r.goal?.balance),
          num(r.measures?.balance),
          pctOrNull(r.attainment?.balance),
          numEntero(partRow.goal?.activeCount),
          numEntero(partRow.measures?.activeCount),
          pctOrNull(partRow.attainment?.activeCount),
          pctOrNull(credAnioRow.attainment?.balance),
          pctOrNull(partAnioRow.attainment?.activeCount),
        ]
      };
    });

    // Orden alfabético por nombre; "Sin asesor" siempre primero.
    suc.asesores.sort((a, b) => {
      const aSin = (a.name ?? '').trim().toLowerCase() === 'sin asesor';
      const bSin = (b.name ?? '').trim().toLowerCase() === 'sin asesor';
      if(aSin && !bSin) return -1;
      if(bSin && !aSin) return 1;
      return (a.name ?? '').localeCompare(b.name ?? '', 'es', { sensitivity: 'base' });
    });

    suc.asesoresPeriodo = per;
    suc.cargandoAsesores = false;
    this.cdr.detectChanges();
  }

  /** Cambia el tipo de gráfica (Combinada, Área o Lineal) de Saldos o de Clientes, independiente una de otra. */
  changeGraph(cual: 'saldos' | 'clientes', t: typesApex){
    if(cual === 'saldos'){ this.chartTypeSaldos = t; }
    else{ this.chartTypeClientes = t; }
    this.actualizarGrafica();
  }

  /** Zona, Agencia o "Consolidado" que se está graficando ahorita mismo. */
  nivelActual(): string{
    const consolidado = this.translate.instant('comercial.asosiatividad.metas.consolidado');
    if(this.consolidadoZona){ return consolidado; }
    if(this.consolidado){
      const zonaSel = this.zonas.find(z => z.check);
      return zonaSel?.name ?? consolidado;
    }
    const agenciaSel = this.sucursales.find(s => s.check);
    return agenciaSel?.name ?? consolidado;
  }

  /** Subtítulo de gráfica: Consolidado, la Zona, o "Zona | Agencia | Asesores" si hay Agencia filtrada. */
  nivelGrafica(): string{
    const consolidado = this.translate.instant('comercial.asosiatividad.metas.consolidado');
    if(this.consolidadoZona){ return consolidado; }
    if(this.consolidado){
      const zonaSel = this.zonas.find(z => z.check);
      return zonaSel?.name ?? consolidado;
    }
    const agenciaSel = this.sucursales.find(s => s.check);
    if(!agenciaSel){ return consolidado; }
    const zonaDeAgencia = this.zonas.find(z => z.sucursales.some(s => s.code === agenciaSel.code));
    const asesores = this.translate.instant('comercial.asosiatividad.metas.titulo-asesores');
    return zonaDeAgencia ? `${zonaDeAgencia.name} | ${agenciaSel.name} | ${asesores}` : `${agenciaSel.name} | ${asesores}`;
  }

  /** true cuando la gráfica está a nivel Asesor (hay una Agencia filtrada). */
  esNivelAsesorGrafica(): boolean{
    return !this.consolidadoZona && !this.consolidado;
  }

  /** Arma las series de Saldos y Clientes, al mismo nivel Zona/Agencia/Asesor que la tabla. */
  private actualizarGrafica(){
    let items: { name: string; code?: number; datos: any[] }[] = [];
    let esNivelAsesor = false;

    if(this.consolidadoZona){
      items = this.zonas.filter(z => z.visible);
    }else if(this.consolidado){
      const zonaSel = this.zonas.find(z => z.check);
      items = zonaSel ? zonaSel.sucursales : [];
    }else{
      const codigoAgenciaSel = this.sucursales.find(s => s.check)?.code;
      const sucSel = this.zonas.flatMap(z => z.sucursales).find(s => s.code === codigoAgenciaSel);
      items = sucSel && this.asesoresVigentes(sucSel) ? sucSel.asesores : [];
      esNivelAsesor = true;
    }

    // Cada gráfica arma su serie con su propio tipo, independiente entre Saldos y Clientes.
    const armarSerie = (offset: number, titulo: string, tipo: typesApex) => {
      const esCombinada = tipo === this.types.COMBO;
      // Orden de mayor a menor por Real; Saldos y Clientes pueden quedar en orden distinto.
      const ordenados = [...items].sort((a, b) => (b.datos?.[offset + 1] ?? 0) - (a.datos?.[offset + 1] ?? 0));
      const labels = esNivelAsesor ? ordenados.map(i => `${i.code}`) : ordenados.map(i => i.name);
      const proyectado = ordenados.map(i => i.datos?.[offset] ?? 0);
      const real = ordenados.map(i => i.datos?.[offset + 1] ?? 0);
      const logrado = ordenados.map(i => i.datos?.[offset + 2] ?? 0);
      const unidad = this.unidadPorMagnitud(Math.max(0, ...proyectado, ...real));

      return {
        labels,
        data: [
          { name: this.translate.instant('comercial.asosiatividad.metas.titulo-4-tabla'), type: esCombinada ? this.types.LINE : tipo, data: logrado },
          { name: this.translate.instant('comercial.asosiatividad.metas.titulo-2-tabla'), type: esCombinada ? this.types.BAR : tipo, data: proyectado },
          { name: this.translate.instant('comercial.asosiatividad.metas.titulo-3-tabla'), type: esCombinada ? this.types.BAR : tipo, data: real },
        ],
        axisY: [`${this.translate.instant('comercial.asosiatividad.metas.titulo-4-tabla')} (%)`, unidad ? `${titulo} (${unidad})` : titulo],
      };
    };

    const saldos = armarSerie(0, this.perspective1, this.chartTypeSaldos);
    this.chartLabelsSaldos = saldos.labels;
    this.chartDataSaldos = saldos.data;
    this.chartAxisYSaldos = saldos.axisY;

    const clientes = armarSerie(3, this.perspective2, this.chartTypeClientes);
    this.chartLabelsClientes = clientes.labels;
    this.chartDataClientes = clientes.data;
    this.chartAxisYClientes = clientes.axisY;
  }

  /** Unidad a mostrar en el eje ("Miles", "Millones", ...) según la magnitud del dato. */
  private unidadPorMagnitud(valor: number): string{
    if(valor >= 1000000000){ return this.translate.instant('comercial.asosiatividad.metas.unidad-miles-millones'); }
    if(valor >= 1000000){ return this.translate.instant('comercial.asosiatividad.metas.unidad-millones'); }
    if(valor >= 1000){ return this.translate.instant('comercial.asosiatividad.metas.unidad-miles'); }
    return '';
  }

  /** % de logro recalculado (para totales de zona, donde sumamos actual/goal de varias agencias). */
  private pctLogro(actual: number, goal: number){
    if(actual==null || goal==null || goal===0){ return 0; }
    return Number((actual*100/goal).toFixed(1));
  }
  /** % de logro tal cual lo manda el backend (attainment = actual/goal), solo multiplicado por 100. */
  private attainmentPct(attainment: number){
    return attainment==null ? 0 : Number((attainment*100).toFixed(1));
  }

  /** % de crecimiento planeado entre meta de diciembre del año anterior y la de este año. Meta contra meta, no contra Real; no cambia con el período. */
  private pctMetaAnual(metaInicial: number, metaDiciembre: number){
    if(metaInicial === 0){ return 0; }
    return Number(((metaDiciembre - metaInicial) * 100 / metaInicial).toFixed(1));
  }

  /** Meta anual (%) de Saldos y Clientes del mismo alcance que las tarjetas (Consolidado/Zona/Agencia). */
  private metaAnualEnAlcance(): { saldo: number; clientes: number }{
    if(this.consolidadoZona){
      return { saldo: this.totalGeneral[6] ?? 0, clientes: this.totalGeneral[7] ?? 0 };
    }
    if(this.consolidado){
      const zonaSel = this.zonas.find(z => z.check);
      return { saldo: zonaSel?.datos?.[6] ?? 0, clientes: zonaSel?.datos?.[7] ?? 0 };
    }
    const codigoAgenciaSel = this.sucursales.find(s => s.check)?.code;
    const sucSel = this.zonas.flatMap(z => z.sucursales).find(s => s.code === codigoAgenciaSel);
    return { saldo: sucSel?.datos?.[6] ?? 0, clientes: sucSel?.datos?.[7] ?? 0 };
  }

  private async getData(){
    this.skeleton = true;
    const per = this.getPeriodo();
    const anio = per.split('-')[0];
    const perAnterior = this.mesAnterior(per);
    const dicInicial = `${Number(anio) - 1}-12`;
    const dicMeta = `${anio}-12`;

    const [credMes, partMes, credMesAnt, partMesAnt, credDicIni, partDicIni, credDicMeta, partDicMeta] = await Promise.all([
      firstValueFrom(this.comercialService.getGoalsCredits({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: per, granularity: PERIODICITY.MONTH}, this.token)),
      firstValueFrom(this.comercialService.getGoalsPartners({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: per, granularity: PERIODICITY.MONTH}, this.token)),
      firstValueFrom(this.comercialService.getGoalsCredits({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: perAnterior, granularity: PERIODICITY.MONTH}, this.token)),
      firstValueFrom(this.comercialService.getGoalsPartners({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: perAnterior, granularity: PERIODICITY.MONTH}, this.token)),
      firstValueFrom(this.comercialService.getGoalsCredits({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: dicInicial, granularity: PERIODICITY.MONTH}, this.token)),
      firstValueFrom(this.comercialService.getGoalsPartners({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: dicInicial, granularity: PERIODICITY.MONTH}, this.token)),
      firstValueFrom(this.comercialService.getGoalsCredits({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: dicMeta, granularity: PERIODICITY.MONTH}, this.token)),
      firstValueFrom(this.comercialService.getGoalsPartners({perspective: PerspectiveIdentifier.BRANCH_OFFICE, period: dicMeta, granularity: PERIODICITY.MONTH}, this.token)),
    ]);

    const balancePorAgenciaAnterior = new Map<number, any>((credMesAnt['results'] ?? []).map((r: any) => [r.code, r.measures.balance]));
    const activosPorAgenciaAnterior = new Map<number, any>((partMesAnt['results'] ?? []).map((r: any) => [r.code, r.measures.activeCount]));

    const balancePorAgencia = new Map<number, any>((credMes['results'] ?? []).map((r: any) => [r.code, r.measures.balance]));
    const activosPorAgencia = new Map<number, any>((partMes['results'] ?? []).map((r: any) => [r.code, r.measures.activeCount]));
    const balanceDicIniPorAgencia = new Map<number, any>((credDicIni['results'] ?? []).map((r: any) => [r.code, r.measures.balance]));
    const activosDicIniPorAgencia = new Map<number, any>((partDicIni['results'] ?? []).map((r: any) => [r.code, r.measures.activeCount]));
    const balanceDicMetaPorAgencia = new Map<number, any>((credDicMeta['results'] ?? []).map((r: any) => [r.code, r.measures.balance]));
    const activosDicMetaPorAgencia = new Map<number, any>((partDicMeta['results'] ?? []).map((r: any) => [r.code, r.measures.activeCount]));

    this.dataTable = [];
    let totSaldoMeta=0, totSaldoReal=0, totCuentaMeta=0, totCuentaReal=0;
    let totSaldoIni=0, totSaldoMetaDic=0, totCuentaIni=0, totCuentaMetaDic=0;
    this.zonas.forEach(z => {
      let saldoMeta=0, saldoReal=0, cuentaMeta=0, cuentaReal=0;
      let saldoIni=0, saldoMetaDic=0, cuentaIni=0, cuentaMetaDic=0;

      z.sucursales.forEach(s => {
        const balance = balancePorAgencia.get(s.code) ?? {actual: 0, goal: 0};
        const activos = activosPorAgencia.get(s.code) ?? {actual: 0, goal: 0};
        // Cartera/Clientes inicial usa la META de diciembre del año anterior, no el real.
        const balanceIni = balanceDicIniPorAgencia.get(s.code)?.goal ?? 0;
        const activosIni = activosDicIniPorAgencia.get(s.code)?.goal ?? 0;
        const balanceMetaDic = balanceDicMetaPorAgencia.get(s.code)?.goal ?? 0;
        const activosMetaDic = activosDicMetaPorAgencia.get(s.code)?.goal ?? 0;

        s.datos = [
          Number((balance.goal ?? 0).toFixed(2)),
          Number((balance.actual ?? 0).toFixed(2)),
          this.attainmentPct(balance.attainment),
          Math.round(activos.goal ?? 0),
          Math.round(activos.actual ?? 0),
          this.attainmentPct(activos.attainment),
          this.pctMetaAnual(balanceIni, balanceMetaDic),
          this.pctMetaAnual(activosIni, activosMetaDic),
        ];

        saldoMeta += balance.goal ?? 0;
        saldoReal += balance.actual ?? 0;
        cuentaMeta += activos.goal ?? 0;
        cuentaReal += activos.actual ?? 0;
        saldoIni += balanceIni;
        saldoMetaDic += balanceMetaDic;
        cuentaIni += activosIni;
        cuentaMetaDic += activosMetaDic;

        // Si cambió el período los asesores quedan viejos; se cierran y se vuelven a traer al expandir.
        s.asesoresExpandido = false;

        if(z.visible){
          const aux: { [key: string]: any } = { colum0: s.name };
          s.datos.forEach((v, i) => aux[`colum${i+1}`] = v);
          this.dataTable.push(aux);
        }
      });

      z.datos = [
        Number(saldoMeta.toFixed(2)),
        Number(saldoReal.toFixed(2)),
        this.pctLogro(saldoReal, saldoMeta),
        Math.round(cuentaMeta),
        Math.round(cuentaReal),
        this.pctLogro(cuentaReal, cuentaMeta),
        this.pctMetaAnual(saldoIni, saldoMetaDic),
        this.pctMetaAnual(cuentaIni, cuentaMetaDic),
      ];

      if(z.visible){
        totSaldoMeta += saldoMeta;
        totSaldoReal += saldoReal;
        totCuentaMeta += cuentaMeta;
        totCuentaReal += cuentaReal;
        totSaldoIni += saldoIni;
        totSaldoMetaDic += saldoMetaDic;
        totCuentaIni += cuentaIni;
        totCuentaMetaDic += cuentaMetaDic;
      }
    });

    this.totalGeneral = [
      Number(totSaldoMeta.toFixed(2)),
      Number(totSaldoReal.toFixed(2)),
      this.pctLogro(totSaldoReal, totSaldoMeta),
      Math.round(totCuentaMeta),
      Math.round(totCuentaReal),
      this.pctLogro(totCuentaReal, totCuentaMeta),
      this.pctMetaAnual(totSaldoIni, totSaldoMetaDic),
      this.pctMetaAnual(totCuentaIni, totCuentaMetaDic),
    ];

    this.actualizarGrafica();
    this.cargarAsesoresParaGrafica();

    // Tarjetas: crecimiento real (mes actual - mes anterior) al mismo nivel que la gráfica.
    let codigosEnAlcance: number[];
    if(this.consolidadoZona){
      codigosEnAlcance = this.zonas.flatMap(z => z.sucursales.map(s => s.code));
    }else if(this.consolidado){
      const zonaSel = this.zonas.find(z => z.check);
      codigosEnAlcance = zonaSel ? zonaSel.sucursales.map(s => s.code) : [];
    }else{
      const agenciaSel = this.sucursales.find(s => s.check);
      codigosEnAlcance = agenciaSel ? [agenciaSel.code] : [];
    }

    let saldoMesActual = 0, saldoMesAnt = 0, clienteMesActual = 0, clienteMesAnt = 0;
    codigosEnAlcance.forEach(codigo => {
      saldoMesActual += balancePorAgencia.get(codigo)?.actual ?? 0;
      saldoMesAnt += balancePorAgenciaAnterior.get(codigo)?.actual ?? 0;
      clienteMesActual += activosPorAgencia.get(codigo)?.actual ?? 0;
      clienteMesAnt += activosPorAgenciaAnterior.get(codigo)?.actual ?? 0;
    });

    const crecimientoSaldo = saldoMesActual - saldoMesAnt;
    const crecimientoCliente = clienteMesActual - clienteMesAnt;
    const pctCrecimientoSaldo = saldoMesAnt === 0 ? 0 : Number((crecimientoSaldo * 100 / saldoMesAnt).toFixed(1));
    const pctCrecimientoCliente = clienteMesAnt === 0 ? 0 : Number((crecimientoCliente * 100 / clienteMesAnt).toFixed(1));

    // Triángulo verde/rojo en las tarjetas de %: ¿ya se alcanzó la Meta anual del mismo alcance (Consolidado/Zona/Agencia)?
    const metaAnual = this.metaAnualEnAlcance();
    const colorSaldo = pctCrecimientoSaldo >= metaAnual.saldo ? '#72D54A' : '#FF495C';
    const colorCliente = pctCrecimientoCliente >= metaAnual.clientes ? '#72D54A' : '#FF495C';

    const pie = this.piePeriodoNivel();
    this.tarjets = [
      { header: this.translate.instant('comercial.asosiatividad.metas.tarjeta-crecimiento-saldo'), valueStr: this.formatearCrecimiento(crecimientoSaldo), footer: pie, showIcon: false },
      { header: this.translate.instant('comercial.asosiatividad.metas.tarjeta-pct-crecimiento-saldo'), valueStr: `${pctCrecimientoSaldo} %`, footer: pie, showIcon: true, icon: 'change_history', iconColor: colorSaldo },
      { header: this.translate.instant('comercial.asosiatividad.metas.tarjeta-crecimiento-clientes'), valueStr: this.formatearCrecimiento(crecimientoCliente), footer: pie, showIcon: false },
      { header: this.translate.instant('comercial.asosiatividad.metas.tarjeta-pct-crecimiento-clientes'), valueStr: `${pctCrecimientoCliente} %`, footer: pie, showIcon: true, icon: 'change_history', iconColor: colorCliente },
    ];
    this.skeleton = false;
  }

  /** Período anterior ("YYYY-MM") al que se le pasa, para el crecimiento mes contra mes. */
  private mesAnterior(per: string): string{
    let [anio, mes] = per.split('-').map(Number);
    mes -= 1;
    if(mes === 0){ mes = 12; anio -= 1; }
    return `${anio}-${String(mes).padStart(2, '0')}`;
  }

  /** Cifra completa de crecimiento (sin abreviar), sin decimales; trunca, no redondea. */
  private formatearCrecimiento(val: number): string{
    return formatear.formatearMoneda(Math.trunc(val), false, ',', '.');
  }

  /** Restaura Zona/Agencia/Período y la vista a su estado por default (igual que indicadores-a1). */
  borrarFiltros(){
    this.zonas.forEach(z => {
      z.check = false;
      z.expandido = true;
    });
    this.consolidadoZona = true;
    this.actualizarSucursalesPorZona();
    this.expandAll = true;
    this.viewTabla = true;
    this.etiquetasShowSaldos = true;
    this.etiquetasShowClientes = true;
    this.chartTypeSaldos = this.types.COMBO;
    this.chartTypeClientes = this.types.COMBO;
    this.yearChange(this.periodoInicial);
  }

  yearChange(event){
    this.periodos.forEach( anio => {
      anio.series.forEach( per => {
        if(per.periodo === event.periodo){
          per.check = true;
          this.month = per.mesS;
        }else{
          per.check = false;
        }
      });
    });
    this.getData();
  }
  zonaChange(zonaClick: any){
    for(const z of this.zonas){
      if(zonaClick !== 'consolidado' && z.name === zonaClick.name){
        z.check = true;
      }else{
        z.check = false;
      }
    }
    this.consolidadoZona = zonaClick === 'consolidado' ? !this.consolidadoZona : false;
    this.actualizarSucursalesPorZona();
    this.getData();
  }
  agencyChange(sucClick: any){
    for(const suc of this.sucursales){
      if(sucClick !== 'consolidado' && suc.name === sucClick.name){
        suc.check = true;
      }else{
        suc.check = false;
      }
    }
    this.consolidado = sucClick === 'consolidado' ? !this.consolidado : false;
    this.getData();
  }

  // Colores oficiales de semáforo del sistema (idsTabla.ts / indicadores-a1).
  getBorderColor(data, col){
    if(data[`colum${col}`] > 80){
      return '#72D54A';
    }else if(data[`colum${col}`] > 50){
      return '#FFD100';
    }else if(data[`colum${col}`] >= 0){
      return '#FF495C';
    }
    return '';
  }
  /** Igual que getBorderColor(), pero para la tabla en pantalla, que ya trae el valor directo. */
  getBorderColorValor(valor: number){
    if(valor > 80) return '#72D54A';
    if(valor > 50) return '#FFD100';
    if(valor >= 0) return '#FF495C';
    return '';
  }
  /** Clase CSS del semáforo (mismo patrón que indicadores-a1: el color va en un div interno, no en el borde del td). */
  getIndicatorClass(valor: number): string{
    if(valor > 80) return 'bordeVerde';
    if(valor > 50) return 'bordeAmarillo';
    if(valor >= 0) return 'bordeRojo';
    return '';
  }
  /** Meta anual (columnas 6 y 7) no es semáforo rojo/verde: siempre gris (igual que seguimiento/indicadores-metas). */
  getIndicatorClassCol(valor: number, index: number): string{
    if(index === 6 || index === 7){ return 'bordeGris'; }
    if(index === 2 || index === 5){ return this.getIndicatorClass(valor); }
    return '';
  }
  /** Decimales por columna, para el separador de miles (formaterNumber): montos=2, conteos=0, %=1. */
  decimalesCol(index: number): number{
    if(index === 3 || index === 4){ return 0; }
    if(index === 0 || index === 1){ return 2; }
    return 1;
  }

  /** Exportación a Excel de la tabla Zona/Agencias, con las mismas columnas visibles en pantalla. */
  exportExcel(){
    const columnasPorcentaje = [2, 5, 6, 7];

    const headers = [
      this.translate.instant('comercial.asosiatividad.metas.titulo-zona-agencias'),
      ...this.encabezados.slice(1).map(enc => this.translate.instant('comercial.asosiatividad.metas.titulo-'+(enc+1)+'-tabla')),
    ];
    const formatos = [
      FormatText.TEXT,
      ...this.encabezados.slice(1).map((enc, i) => columnasPorcentaje.includes(i) ? FormatText.PORCENTAJE : FormatText.NUMBERDEC),
    ];
    const aligment = [
      Aligment.LEFT,
      ...this.encabezados.slice(1).map(() => Aligment.RIGHT),
    ];

    const data = [], colors = [], filasResaltadas = [];
    this.zonas.forEach(z => {
      if(z.visible){
        data.push([z.name, ...z.datos.map((v, i) => columnasPorcentaje.includes(i) ? v/100 : v)]);
        colors.push(['', ...z.datos.map(() => '')]);
        filasResaltadas.push(true);

        z.sucursales.forEach(s => {
          // Indentación visual de Agencia bajo su Zona (mismo criterio que catálogo de cuentas en excel.service.ts).
          data.push(['   ' + s.name, ...s.datos.map((v, i) => columnasPorcentaje.includes(i) ? v/100 : v)]);
          // Meta anual (columnas 6 y 7) siempre gris, igual que en pantalla (ver getIndicatorClassCol).
          colors.push(['', ...s.datos.map((v, i) => {
            if(i === 6 || i === 7){ return '#C8C7C8'; }
            return columnasPorcentaje.includes(i) ? this.getBorderColorValor(v) : '';
          })]);
          filasResaltadas.push(false);
        });
      }
    });

    this.excel.generateExcelSinTitulo(headers, data, this.translate.instant('comercial.asosiatividad.metas.encabezado')+' - '+this.getPeriodo(), aligment, formatos, colors, filasResaltadas);
  }

  /** Exporta la gráfica de Saldos como imagen, independiente de la de Clientes. */
  exportImageSaldos(){
    const titulo = this.translate.instant('comercial.asosiatividad.metas.encabezado');
    const per = this.getPeriodo();
    this.graficasSaldos.exportImg(1, {
      titulo,
      subtitulo: `${this.perspective1} | ${per}`,
      nombreArch: `${titulo} - ${this.perspective1}`,
    });
  }
  /** Exporta la gráfica de Clientes como imagen, independiente de la de Saldos. */
  exportImageClientes(){
    const titulo = this.translate.instant('comercial.asosiatividad.metas.encabezado');
    const per = this.getPeriodo();
    this.graficasClientes.exportImg(2, {
      titulo,
      subtitulo: `${this.perspective2} | ${per}`,
      nombreArch: `${titulo} - ${this.perspective2}`,
    });
  }

  async exportarPDF(){
    try{
      messages.messageSaving(this.translate.instant('acciones.descarga'),this.translate.instant('acciones.espera'))

      const fechaPiePag = new Date().toLocaleDateString('es-MX', {month: '2-digit',day: '2-digit',year: '2-digit',});
      const horaPiePag = new Date().toLocaleTimeString('es-MX');
      const currentUser = this.dataService.user;

      const docPDF = {
        pageSize: 'FOLIO',
        images: {
          logoAleema: ConstantesImagenes.fondoblanco,
        },
        footer: function (currentPage, pageCount){
          if(currentPage == 1){
            return null;
          }
          if(currentPage === pageCount){
            return{
              columns: [
                {
                  image: 'logoAleema',
                  width: 70,
                  margin: [30, -1, 30, 0],
                },
                {
                  text: `${currentUser}  |  ${fechaPiePag}  |  ${horaPiePag}`,
                  alignment: 'center',
                  width: '*',
                  color: '#808080',
                  fontSize: 10,
                },

                {
                  text: (currentPage - 1).toString(),
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                  margin: [10, -1, 30, 0],
                },
              ]
            }
          }else{
            return{
              text: {
                  text: (currentPage - 1).toString(),
                  alignment: 'right',
                  color: '#808080',
                  fontSize: 10,
                  width: 'auto',
                },margin: [10, -1, 30, 0],
            }
          }
        },
        pageOrientation: 'landscape',
        content: [
          await this.generateTablePDF(),
        ]
      }

      var reportName = 'Reporte general';
      const pdf = pdfMake.createPdf(docPDF);
      
      pdf.download(reportName);
      const blob = await pdf.getBlob();
      this.pdfFile = blob;

      Swal.close();
      messages.succesMessageGraph(this.translate.instant('acciones.desExito'))
    }catch(error){
      Swal.close();
      Swal.fire({title: this.translate.instant('cues.reporte.errorReporte'), timer: 10000});
    }
  }
  private async generateTablePDF(){
    var headers = [];
    var data = [];

    const h1 = [
      {text: '', col: 1},
      {text: this.month, col: 6},
      {text: '', col: 2},
    ];
    const h2 = [
      {text: '', col: 1},
      {text: this.perspective1, col: 3},
      {text: this.perspective2, col: 3},
      {text: this.translate.instant('comercial.asosiatividad.metas.titulo-encabezado-1'), col: 2},
    ];
    const h3 = [
      ...this.encabezados.flatMap( (e, index) => { return { text: this.translate.instant('comercial.asosiatividad.metas.titulo-'+(index+1)+'-tabla'), col:1 } }),
    ];

    headers.push(h1,h2,h3);
    var data = [];
    for(const d of this.dataTable){
      data.push(
        this.encabezados.map( (e, i) => {
          return {
            text: `${d[`colum${i}`]}`,
            border_color: i === 3 || i === 6 || i === 7 || i === 8  ? [this.getBorderColor(d, i), '#d6d6d6', '#d6d6d6', '#d6d6d6']:['#d6d6d6', '#d6d6d6', '#d6d6d6', '#d6d6d6'],
            border: i === 3 || i === 6 || i === 7 || i === 8  ? [true, true, false, true]:undefined,
          }
        })
      )
    }

    const head = await generatePDF.titles(this.translate.instant('comercial.asosiatividad.metas.encabezado'),this.getPeriodo());
    const tab = await generatePDF.table(headers, data);
    return [head, tab];
  }

}
